'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Film = require('./Film');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Film).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-icons/lib/components/Film/index.js
// module id = 1186
// module chunks = 1